import { IconButton, ModalHeader, VisuallyHidden } from '@coop/components';
import { CloseIcon } from '@coop/icons';
import classnames from 'classnames';
import type { FC } from 'react';

import { isProductionEnvironment } from '../../../../utility/environments';
import { FlyIn } from '../../../common/components/atoms/Modal';
import useModal from '../../../common/hooks/useModal';
import { FlyInType } from '../../../common/store/structureDefinitions/modalState';
import styles from './SustainabilityFlyinModal.module.less';

const getEnv = () => {
    if (isProductionEnvironment) return 'www';

    return 'www-qa';
};

const SustainabilityFlyinModal: FC<
    React.PropsWithChildren<{ ean: string; missingData: boolean }>
> = ({ ean, missingData }) => {
    const { isOpen, close } = useModal(FlyInType.SustainabilityDeclaration);

    const url = new URL(`https://${getEnv()}.coop-cdn.se/sustainabilityv2/`);
    url.searchParams.set('barcode', ean);
    url.searchParams.set('mode', 'desktop');

    if (missingData) {
        url.searchParams.set('missing_data', 'true');
    }

    return (
        <FlyIn
            isOpen={isOpen}
            close={close}
            sizePx={460}
            additionalClasses="u-textCenter u-paddingHz"
        >
            <VisuallyHidden>
                <ModalHeader>Hållbarhetsdeklaration</ModalHeader>
            </VisuallyHidden>
            <IconButton
                icon={CloseIcon}
                theme="primary"
                size={40}
                label="Stäng hållbarhetsdeklarationsdialog"
                onClick={close}
                className={styles.CloseIcon}
            />
            <div className="u-flexGrow u-posRelative">
                <iframe
                    src={url.toString()}
                    className={classnames(styles.Iframe, styles.V2)}
                    frameBorder="0"
                    // according to axe rule interactive iframes should have tabIndex="0"
                    // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
                    tabIndex={0}
                    title="Hållbarhetsdeklaration"
                />
            </div>
        </FlyIn>
    );
};

export default SustainabilityFlyinModal;
